let selectedProjectInfo = {
    projectid:''
}

export default selectedProjectInfo;